[
    {
        "actions": null,
        "advisorType": null,
        "bannerURL": null,
        "category": 2,
        "categoryContentId": 0,
        "creationDate": null,
        "description": null,
        "fileUrl": null,
        "id": 3,
        "index": null,
        "internalDescription": null,
        "isFavorite": false,
        "isHome": false,
        "isLevelWithDescription": false,
        "isSuggested": false,
        "level": true,
        "levelTwo": false,
        "order": 0,
        "parentId": 0,
        "positionImage": null,
        "range": null,
        "redirect": null,
        "referenceImage": null,
        "sharedCount": 0,
        "subLevelContentId": 0,
        "suggestedText": null,
        "textToShare": null,
        "title": "MI POBLACIÓN",
        "type": null,
        "whenToUse": null,
        "sublevel":[
            {
              "id": 33,
              "title": "Consulta Mis Usuarios Población",
              "description": "Desripcion Interna contenido",
              "actions": null,
              "advisorType": "INTERNO,EXTERNO",
              "bannerURL": "https://com-proximate-production-coomeva-resources.s3.amazonaws.com/ova/logo-no-text.webp",
              "category": 2,
              "categoryContentId": 3,
              "creationDate": "2024-07-12",
              "fileUrl": "https://com-proximate-production-coomeva-resources.s3.amazonaws.com/ova/files/eba.pdf",
              "index": "f0e4e86d-4fba-45dc-8d8b-31649872f0cc",
              "internalDescription": null,
              "isFavorite": false,
              "isHome": true,
              "isLevelWithDescription": false,
              "isSuggested": false,
              "level": false,
              "levelTwo": false,
              "order": 1,
              "parentId": 0,
              "positionImage": null,
              "range": "12 de julio de 2024 - 31 de agosto de 2025",
              "redirect": "/main/poblacion",
              "referenceImage": null,
              "sharedCount": 0,
              "subLevelContentId": 0,
              "sublevel": null,
              "suggestedText": "Texto de sugerido al compartir",
              "textToShare": null,
              "type": null,
              "whenToUse": "Texto de cuando utilizar"
            },
            {
              "id": 34,
              "title": "Consulta Mi Población",
              "description": "Desripcion Interna contenido",
              "actions": null,
              "advisorType": "INTERNO,EXTERNO",
              "bannerURL": "https://com-proximate-production-coomeva-resources.s3.amazonaws.com/ova/logo-no-text.webp",
              "category": 2,
              "categoryContentId": 3,
              "creationDate": "2024-07-12",
              "fileUrl": "https://com-proximate-production-coomeva-resources.s3.amazonaws.com/ova/files/eba.pdf",
              "index": "ddbd6eec-a705-4943-b17d-7053d262e76e",
              "internalDescription": null,
              "isFavorite": false,
              "isHome": true,
              "isLevelWithDescription": false,
              "isSuggested": false,
              "level": false,
              "levelTwo": false,
              "order": 2,
              "parentId": 0,
              "positionImage": null,
              "range": "12 de julio de 2024 - 31 de agosto de 2025",
              "redirect": "/main/consultapoblacion",
              "referenceImage": null,
              "sharedCount": 0,
              "subLevelContentId": 0,
              "sublevel": null,
              "suggestedText": "Texto de sugerido al compartir",
              "textToShare": null,
              "type": null,
              "whenToUse": "Texto de cuando utilizar"
            }
          ]          
      }
    
    
]